import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * LegalLayout — shared shell for /privacy and /terms.
 * Editorial onyx layout, narrow reading column, clean typography.
 */
const LegalLayout = ({ eyebrow, title, lastUpdated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-onyx grain">
      {/* Top bar */}
      <div className="border-b border-pewter/60">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12 py-5 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-platinum hover:text-blush transition-colors text-[11px] tracking-[0.22em] uppercase"
            data-testid="legal-back-home"
          >
            <ArrowLeft size={14} />
            Return Home
          </Link>
          <p className="text-[10px] tracking-[0.32em] uppercase text-silverx">
            Snatched Beauties <span className="brand-italic chrome-rose">Privé</span>
          </p>
        </div>
      </div>

      {/* Content */}
      <article className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24">
        <p className="eyebrow chrome-rose mb-6">
          <span className="inline-block w-8 h-px bg-blush align-middle mr-3" />
          {eyebrow}
        </p>
        <h1 className="font-serif text-ivory text-5xl lg:text-6xl leading-[1.02] mb-6 text-balance">
          {title}
        </h1>
        <p className="text-silverx text-[11px] tracking-[0.22em] uppercase mb-12">
          Last Updated · {lastUpdated}
        </p>
        <div className="hairline mb-12" />
        <div className="legal-body space-y-8 text-platinum text-[15px] leading-[1.8]">
          {children}
        </div>

        <div className="hairline mt-16 mb-8" />
        <p className="text-silverx/80 text-[12px] leading-relaxed">
          Questions about this document? Email{' '}
          <a
            href="mailto:support@snatchedbeauties.com"
            className="text-blush hover:underline"
          >
            support@snatchedbeauties.com
          </a>{' '}
          or call <a href="tel:3236135153" className="text-blush hover:underline">323-613-5153</a>.
        </p>
      </article>
    </div>
  );
};

export default LegalLayout;
